<ngb-carousel [showNavigationArrows]="false">
  <ng-template ngbSlide *ngFor="let data of bannerData">
    <div class="picsum-img-wrapper">
      <img [src]="data.image.Src" alt="" />
    </div>

    <div class="carousel-caption">
      <div class="float-rit" [innerHTML]="data.description | safeHtml"></div>
    </div>
  </ng-template>
</ngb-carousel>
